import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "checked", "disabled", "required"]
const _hoisted_3 = {
  key: 0,
  class: "ui-toggle__text"
}
const _hoisted_4 = {
  key: 0,
  class: "ui-toggle__helper"
}
const _hoisted_5 = {
  key: 0,
  class: "ui-toggle__error"
}
const _hoisted_6 = {
  key: 1,
  class: "ui-toggle__helper-text"
}

import { computed, ref } from "vue";
import type { Size } from "./types";

interface Props {
  modelValue?: boolean;
  label?: string;
  size?: Size;
  disabled?: boolean;
  required?: boolean;
  error?: string;
  helperText?: string;
  id?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Toggle',
  props: {
    modelValue: { type: Boolean },
    label: {},
    size: { default: "md" },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    error: {},
    helperText: {},
    id: {}
  },
  emits: ["update:modelValue", "blur", "focus", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isFocused = ref(false);
const toggleId = computed(() => props.id || `toggle-${Math.random().toString(36).substr(2, 9)}`);

const wrapperClasses = computed(() => {
  const classes = ["ui-toggle"];
  classes.push(`ui-toggle--${props.size}`);
  if (props.disabled) classes.push("ui-toggle--disabled");
  if (props.error) classes.push("ui-toggle--error");
  return classes;
});

const toggleClasses = computed(() => {
  const classes = ["ui-toggle__input"];
  if (isFocused.value) classes.push("ui-toggle__input--focused");
  return classes;
});

const handleChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const value = target.checked;
  emit("update:modelValue", value);
  emit("change", value);
};

const handleBlur = (event: FocusEvent) => {
  isFocused.value = false;
  emit("blur", event);
};

const handleFocus = (event: FocusEvent) => {
  isFocused.value = true;
  emit("focus", event);
};

const handleLabelClick = (event: MouseEvent) => {
  if (props.disabled) {
    event.preventDefault();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(wrapperClasses.value)
  }, [
    _createElementVNode("label", {
      for: toggleId.value,
      class: "ui-toggle__label",
      onClick: handleLabelClick
    }, [
      _createElementVNode("input", {
        id: toggleId.value,
        type: "checkbox",
        checked: __props.modelValue,
        disabled: __props.disabled,
        required: __props.required,
        class: _normalizeClass(toggleClasses.value),
        onChange: handleChange,
        onBlur: handleBlur,
        onFocus: handleFocus
      }, null, 42, _hoisted_2),
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "ui-toggle__switch" }, [
        _createElementVNode("span", { class: "ui-toggle__slider" })
      ], -1)),
      (__props.label)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.label), 1))
        : _createCommentVNode("", true)
    ], 8, _hoisted_1),
    (__props.error || __props.helperText)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (__props.error)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.error), 1))
            : (__props.helperText)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(__props.helperText), 1))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})